"use client";
import React from "react";
import Image from "next/image";
import { useDictionary } from "@/components/DictProvider/DictProvider";

const CouponNotFound = () => {
  const dict = useDictionary();
  return (
    <div className="min-h-[calc(100vh-132px)] md:min-h-[calc(100vh-156px)] w-full flex justify-center items-center">
      <div className="flex flex-col justify-center items-center gap-8">
        <Image
          src={"/images/coupon_not_found.png"}
          width={215}
          height={105}
          alt="oops"
        />
        <div className="flex flex-col gap-2">
          <p className="text-lg md:text-2xl font-semibold text-center">
            {dict.myCoupon.noCouponFound}
          </p>
          <p className="text-center text-sm md:text-base text-black/60">
            {dict.myCoupon.noCouponFoundDesc}
          </p>
        </div>
      </div>
    </div>
  );
};

export default CouponNotFound;
